function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-plane"), React.createElement("g", {
  id: "icon-plane-icon-plane",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M45.1071588,82.4444444 L35.2895383,82.4444444 L41.2579596,58.3824956 L7.24128524,58.3824956 L0,51.0951175 L0,30.0306459 L9.49757471,30.0306459 L15.4666613,42.0619488 L41.2579596,42.0619488 L35.2895383,18 L45.1071588,18 L63.0470221,42.0619488 L85.863425,42.0619488 C85.9978309,42.0619488 89.1650199,42.0711475 92.3847735,42.8812943 C99.0105861,44.5482385 100,48.1961984 100,50.2225507 C100,50.5556768 99.838979,58.3824956 85.863425,58.3824956 L63.0470221,58.3824956 L45.1071588,82.4444444 Z M40.8015117,78.173598 L42.9207338,78.173598 L60.8619279,54.1116492 L85.863425,54.1116492 C95.2538742,54.1116492 95.6750571,50.2613169 95.6750571,50.2225507 C95.6750571,47.3118046 88.9381267,46.3327952 85.863425,46.3327952 L60.8619279,46.3327952 L42.9207338,22.2708464 L40.8015117,22.2708464 L46.769933,46.3327952 L12.7692277,46.3327952 L6.80080644,34.3014923 L4.32494294,34.3014923 L4.32494294,49.349984 L9.0570959,54.1116492 L46.769933,54.1116492 L40.8015117,78.173598 Z",
  id: "icon-plane-Fill-1",
  fill: "#000"
}))));